import React from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';

function ToastMessage({ show, onClose, variant = 'light', content }) {
  return (
    <ToastContainer position="bottom-end" className="p-3">
      <Toast show={show} onClose={onClose} bg={variant} delay={4000} autohide>
        <Toast.Header>
          <strong className="me-auto">وضعیت</strong>
        </Toast.Header>
        <Toast.Body style={{ whiteSpace: 'pre-line' }}>{content}</Toast.Body>
      </Toast>
    </ToastContainer>
  );
}

export default ToastMessage;
